import page from "../_snowpack/pkg/page.js";
import * as navigation from "./interactors/navigation.js";
export const goToArtworks = () => page("/");
export const goToArtwork = (id) => page(`/artwork/${id}`);
export default function init() {
  page("/", () => navigation.goToArtworks());
  page("/artwork/:uid", (ctx) => navigation.goToArtwork(ctx.params.uid));
  page.start();
}
